/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export const SHOW_WHISPER = 'SHOW_WHISPER';
export const HIDE_WHISPER = 'HIDE_WHISPER';
